/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Unknown_PlayerInputs */

const th_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบผู้เล่นคนนี้`)
};

const en_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That player does not exist.`)
};

const ja_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この選手は存在しません。`)
};

const zh_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该球员不存在。`)
};

const es_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese jugador no existe.`)
};

const pt_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse jogador não existe.`)
};

const id_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain itu tidak ada.`)
};

const fr_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce joueur n’existe pas.`)
};

const tl_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang manlalarong iyon.`)
};

const vi_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có cầu thủ đó.`)
};

const ko_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 선수는 없습니다.`)
};

const de_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Spieler gibt es nicht.`)
};

const ru_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого игрока нет.`)
};

const tr_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir oyuncu yok.`)
};

const it_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel giocatore non esiste.`)
};

const pl_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taki zawodnik nie istnieje.`)
};

const uk_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого гравця немає.`)
};

const hi_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह खिलाड़ी मौजूद नहीं है।`)
};

const ar_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذلك اللاعب غير موجود.`)
};

const ms_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain itu tidak wujud.`)
};

const bn_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই খেলোয়াড় নেই।`)
};

const zh_tw2_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該球員不存在。`)
};

const zh_hk2_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該球員不存在。`)
};

const ur_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ کھلاڑی موجود نہیں۔`)
};

const fa_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین بازیکنی وجود ندارد.`)
};

const sw_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji huyo hayupo.`)
};

const nl_err_unknown_player = /** @type {(inputs: Err_Unknown_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die speler bestaat niet.`)
};

/**
* | output |
* | --- |
* | "That player does not exist." |
*
* @param {Err_Unknown_PlayerInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_unknown_player = /** @type {((inputs?: Err_Unknown_PlayerInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Unknown_PlayerInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_unknown_player(inputs)
	if (locale === "ja") return ja_err_unknown_player(inputs)
	if (locale === "zh") return zh_err_unknown_player(inputs)
	if (locale === "es") return es_err_unknown_player(inputs)
	if (locale === "pt") return pt_err_unknown_player(inputs)
	if (locale === "id") return id_err_unknown_player(inputs)
	if (locale === "fr") return fr_err_unknown_player(inputs)
	if (locale === "tl") return tl_err_unknown_player(inputs)
	if (locale === "vi") return vi_err_unknown_player(inputs)
	if (locale === "ko") return ko_err_unknown_player(inputs)
	if (locale === "de") return de_err_unknown_player(inputs)
	if (locale === "ru") return ru_err_unknown_player(inputs)
	if (locale === "tr") return tr_err_unknown_player(inputs)
	if (locale === "it") return it_err_unknown_player(inputs)
	if (locale === "pl") return pl_err_unknown_player(inputs)
	if (locale === "uk") return uk_err_unknown_player(inputs)
	if (locale === "hi") return hi_err_unknown_player(inputs)
	if (locale === "ar") return ar_err_unknown_player(inputs)
	if (locale === "ms") return ms_err_unknown_player(inputs)
	if (locale === "bn") return bn_err_unknown_player(inputs)
	if (locale === "zh-TW") return zh_tw2_err_unknown_player(inputs)
	if (locale === "zh-HK") return zh_hk2_err_unknown_player(inputs)
	if (locale === "ur") return ur_err_unknown_player(inputs)
	if (locale === "fa") return fa_err_unknown_player(inputs)
	if (locale === "sw") return sw_err_unknown_player(inputs)
	if (locale === "nl") return nl_err_unknown_player(inputs)
	return en_err_unknown_player(inputs)
});